const EDITOR_VERSION = "17.0.0";

export default EDITOR_VERSION;
